import { useCallback } from 'react';
import { images } from 'common/utils';
import type { InvitationSearchOptionLabel } from '../../types';

export const useGetOptionLabelProperties = () =>
  useCallback((option: InvitationSearchOptionLabel) => {
    switch (option.type) {
      case 'community':
        return {
          description: 'Community',
          fallbackPhoto: images.default.communityProfilePhoto,
          photo: option.profilePhoto,
          title: option.label,
        };
      case 'email':
        return {
          description: 'Non-registered user',
          photo: images.default.userProfilePhoto,
          title: option.label,
        };
      case 'user':
        return {
          description: option.email,
          photo: option.profilePhoto ?? images.default.userProfilePhoto,
          title: option.label,
        };
    }
  }, []);
